import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`

export const Labels = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
`

export const Label = styled.span`
  color: #202020;
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  opacity: 0.75;
`

export const Hint = styled.span`
  color: #808080;
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  opacity: 0.75;
`

export const UploadLink = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
  height: 32px;
  margin: 0;
  padding: 0 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #2684ff;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) {
    color: #1890ff;
    background: rgba(38, 132, 255, 0.06);
  }

  &:disabled {
    opacity: 0.48;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
    font-size: 14px;
  }
`

export const SelectedFile = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  margin-top: 4px;
`

export const FileName = styled.span`
  overflow: hidden;
  color: #2b9c6a;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const RemoveFileButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  color: #757575;
  cursor: pointer;

  &:hover:not(:disabled) {
    color: #363636;
  }

  &:disabled {
    opacity: 0.48;
    cursor: not-allowed;
  }
`

export const HiddenInput = styled.input`
  display: none;
`
